import { render, staticRenderFns } from "./ContactAdressAddModalBody.vue?vue&type=template&id=0aec2d0e&scoped=true&"
import script from "./ContactAdressAddModalBody.vue?vue&type=script&lang=js&"
export * from "./ContactAdressAddModalBody.vue?vue&type=script&lang=js&"
import style0 from "./ContactAdressAddModalBody.vue?vue&type=style&index=0&id=0aec2d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aec2d0e",
  null
  
)

export default component.exports